import { z } from 'zod';

import { SQUAD_DEFAULTS } from '../constants/squad';
import { IdSchema } from './common';

/**
 * Предложение своей активности (BLUEPRINT 3.5, ADR-9):
 * название 3–40 символов, размеры 2–16, до 3 значений, нужен ли уровень.
 */
export const ActivityProposalInputSchema = z.object({
  cityId: IdSchema,
  name: z.string().trim().min(3, 'Название от 3 символов').max(40, 'Название до 40 символов'),
  description: z.string().trim().min(10, 'Опиши в двух словах, что это').max(500),
  sizeOptions: z
    .array(
      z
        .number()
        .int()
        .min(SQUAD_DEFAULTS.proposalSizeMin, `Минимум ${SQUAD_DEFAULTS.proposalSizeMin}`)
        .max(SQUAD_DEFAULTS.proposalSizeMax, `Максимум ${SQUAD_DEFAULTS.proposalSizeMax}`),
    )
    .min(1, 'Укажи, сколько нужно людей')
    .max(
      SQUAD_DEFAULTS.proposalMaxSizeOptions,
      `Не больше ${SQUAD_DEFAULTS.proposalMaxSizeOptions} вариантов`,
    )
    .refine((arr) => new Set(arr).size === arr.length, 'Размеры не должны повторяться')
    .transform((arr) => [...arr].sort((a, b) => a - b)),
  needsLevel: z.boolean(),
  venueHint: z.string().trim().max(200).optional(),
});
export type ActivityProposalInput = z.infer<typeof ActivityProposalInputSchema>;
